import React, { useEffect, useMemo,useRef, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Grid,
  Box,
  Button,
  TextField,
  InputAdornment,
  Card,
  Typography, useMediaQuery, useTheme,
  Select,
  MenuItem,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from "@mui/material";
import {
  useDeleteCustomerMutation,
  useGetCompanyQuery,
  useGetCustomerQuery,
  useGetWorkOrderQuery, 
  useGetBillQuery, 
  useGetAllInvoiceQuery,
} from "../../../Api/attoDeskApi";
import {
  ICompanyDetails,
  IQuoteWorkOrder,
  IInvoice,
} from "../../../Api/Interface/api.interface";
import DeletePopup from "../../../Components/Delete/DeletePopup";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import { useNavigate,Link } from "react-router-dom";
import { useStyles } from "../../../theme/appStyles";
import { useNotifier } from "../../../Core/Notifier";
import { CiSearch } from "react-icons/ci";
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import VisibilitySharpIcon from "@mui/icons-material/VisibilitySharp";
import CustomCheckbox from "../../../Components/Checkbox.tsx";
import Pagination from "../../../Components/Pagination";
import { WorkOrderStatus } from "../../../Core/Enum/enum";
import ReactToPrint from "react-to-print";
import LocalPrintshopSharpIcon from "@mui/icons-material/LocalPrintshopSharp";
import dayjs from "dayjs";
import DescriptionIcon from '@mui/icons-material/Description';
import ViewWorkOrder from "../Components/ViewWorkOrder";
import LinkIcon from '@mui/icons-material/Link';


const getStatusLabel = (statusCode: number): string => {
  switch (statusCode) {
    case WorkOrderStatus.Paid:
      return "Paid";
    case WorkOrderStatus.Cancel:
      return "Canceled";
    case WorkOrderStatus.Pending:
      return "Pending";
      case WorkOrderStatus.Initiated:
        return "Initiated";
    default:
      return "Unknown Status";
  }
};

const getStatusColor = (statusCode: number): string => {
  switch (statusCode) {
    case WorkOrderStatus.Paid:
      return "#4caf50";
    case WorkOrderStatus.Cancel:
      return "#f44336";
    case WorkOrderStatus.Pending:
      return "#ff9800";
       case WorkOrderStatus.Initiated:
  return "#2196f3"
    default:
      return "#9e9e9e";
  }
};

const Index = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { showErrorMessage, showMessage } = useNotifier();
  const [searchQuery, setSearchQuery] = useState("");
  const [currentSearchQuery, setCurrentSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [selectedCoursing, setSelectedCoursing] =
    useState<IQuoteWorkOrder | null>(null);
  const debouncedSearchQuery = useDebounce(searchQuery, 300);
  const [openDialog, setOpenDialog] = useState(false);
  const [openDeleteCategory, setOpenDeleteCategory] = useState(false);
  const [coursingToDelete, setCoursingToDelete] =
    useState<IQuoteWorkOrder | null>(null);
  const [invoiceList, setInvoiceList] = useState<IInvoice[]>([]);
    const capitalize = (str: string) => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  const [dateFilter, setDateFilter] = useState<string>("");
  const [startDate, setStartDate] = useState<string>("");
  const [endDate, setEndDate] = useState<string>("");
  const componentRef = useRef<HTMLDivElement>(null);
  const [quoteId, setQuoteId] = useState("");
  const [openViewQuote, setOpenViewQuote] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));


  const { data, isLoading, isError, refetch } = useGetBillQuery({
    searchText: currentSearchQuery,
    id: "",
  });

  
  const { data: invoiceData, isLoading: invoiceLoading, refetch: invoiceRefetch} = useGetAllInvoiceQuery({
    searchText: "",
      id: "",
      quoteWorkOrderCustomerId: "",
      quoteWorkOrderCustomerProjectId: "",
    });

  const { data: companyData, isLoading: companyLoading } = useGetCompanyQuery({
    searchText: "",
    id: "",
  });

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  useEffect(() => {
    if (debouncedSearchQuery.length >= 4 || debouncedSearchQuery === "") {
      setCurrentSearchQuery(debouncedSearchQuery);
      refetch();
    }
  }, [debouncedSearchQuery]);

   useEffect(() => {
     if (dateFilter !== "custom") {
       let start = "";
       let end = "";
       const now = dayjs().tz("America/Toronto");
       //const now = dayjs().tz("Etc/GMT+12");
   
       switch (dateFilter) {
         case "today":
           start = end = now.format("YYYY-MM-DD");
           break;
         case "yesterday":
           start = end = now.subtract(1, "day").format("YYYY-MM-DD");
           break;
         case "this_week":
           start = now.startOf("week").format("YYYY-MM-DD");
           end = now.endOf("week").format("YYYY-MM-DD"); //  Include full week
           break;
         case "last_week":
           start = now.subtract(1, "week").startOf("week").format("YYYY-MM-DD");
           end = now.subtract(1, "week").endOf("week").format("YYYY-MM-DD");
           break;
         case "this_month":
           start = now.startOf("month").format("YYYY-MM-DD");
           end = now.endOf("month").format("YYYY-MM-DD"); //  Ensure full month is covered
           break;
         case "last_month":
           start = now.subtract(1, "month").startOf("month").format("YYYY-MM-DD");
           end = now.subtract(1, "month").endOf("month").format("YYYY-MM-DD");
           break;
         default:
           break;
       }
   
       setStartDate(start);
       setEndDate(end);
     }
   }, [dateFilter]);


  useEffect(() => {
    if (invoiceList.length === 0) {
      invoiceRefetch(); // Trigger the refetch immediately
    }
  }, [invoiceList, invoiceRefetch]);

  // Update invoiceList when invoiceData is fetched
  useEffect(() => {
    if (invoiceData?.data) {
      const invoiceDataArray = Array.isArray(invoiceData?.data) ? invoiceData.data : [];
      setInvoiceList(invoiceDataArray);
    }
  }, [invoiceData]);

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleOpenDialog = (coursing: IQuoteWorkOrder) => {
    setSelectedCoursing(coursing);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setSelectedCoursing(null);
    setOpenDialog(false);
  };

  const handleOpenDeletePopup = (coursing: IQuoteWorkOrder) => {
    setCoursingToDelete(coursing);
    setOpenDeleteCategory(true);
  };

  const handleCloseDeletePopup = () => {
    setCoursingToDelete(null);
    setOpenDeleteCategory(false);
  };

  const [deleteCategory] = useDeleteCustomerMutation();
  const handleDelete = async (id: string) => {
    try {
      const response = await deleteCategory(id).unwrap();
      if (response.status) {
        showMessage("Deleted successfully");
        setOpenDeleteCategory(false);
      } else {
        showErrorMessage("Failed to delete the customer");
      }
    } catch (error) {
      showErrorMessage("Failed to delete the customer");
    }
  };

  if (isLoading)
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );

  const coursings: IQuoteWorkOrder[] = Array.isArray(data?.data)
    ? (data?.data as IQuoteWorkOrder[])
    : [];

   const filteredCoursings = coursings.filter((row) => {

      const matchesCompany = Number(row.quoteWorkOrderCompanyId) === 1;
  const matchesDate =
    !dateFilter ||
    (() => {
      if (!row.created_at) return false;

      const createdDate = new Date(row.created_at).toLocaleDateString("en-CA");
      const startDateString = new Date(startDate).toLocaleDateString("en-CA");
      const endDateString = new Date(endDate).toLocaleDateString("en-CA");

      return createdDate >= startDateString && createdDate <= endDateString;
    })();

return matchesDate;
});




  const handleSearch = () => {
    setCurrentSearchQuery(searchQuery);
  };

  const resetFields = () => {
    setSearchQuery("");
    setCurrentSearchQuery("");
    refetch();
  };


  const handleAddProductClick = () => {
    navigate("/bill/create");
  };

  const handleInvoiceClick = (invoiceId: number) => {
    navigate(`/invoice/history/${invoiceId}`);
  };

  
   const handleOpenViewQuote = (transactionId: string) => {
        setQuoteId(transactionId);
        setOpenViewQuote(true);
        //console.log(transactionId);
      };

        const handleCloseViewQuote = () => {
        setOpenViewQuote(false);
        setQuoteId("");
      };

  return (
<>
    <div>
       <Grid container spacing={1} sx={{ marginTop: 1 }}>
         <Grid item xs={12}>
           <Card className={classes.card}>
             {/* <Box mb={2} padding={2}> */}
               {/* <Grid container spacing={2}> */}
            
                 {/* <Grid item lg={2} md={2} sm={6} xs={12}>
                 
                 </Grid> */}
    
                 {/* Select Date */}
                 {/* <Grid item lg={2} md={2} sm={6} xs={12}>
                   <Typography variant="subtitle1" sx={{ marginBottom: 1 }}>
                     Select Date
                   </Typography>
                   <Select
                     className={classes.textField}
                     value={dateFilter}
                     onChange={(e) => setDateFilter(e.target.value)}
                     displayEmpty
                    
                     sx={{
                      height: "37px",
                      fontSize: "14px",
                      padding: "4px",
                      minWidth: "120px"
                    }}
                   >
                     <MenuItem value="">Select date filter</MenuItem>
                     <MenuItem value="today">Today</MenuItem>
                     <MenuItem value="yesterday">Yesterday</MenuItem>
                     <MenuItem value="this_week">This Week</MenuItem>
                     <MenuItem value="last_week">Last Week</MenuItem>
                     <MenuItem value="this_month">This Month</MenuItem>
                     <MenuItem value="last_month">Last Month</MenuItem>
                     <MenuItem value="custom">Custom</MenuItem>
                   </Select>
                 </Grid>
     
            
                 {dateFilter === "custom" && (
                   <>
                     <Grid item lg={2} md={2} sm={6} xs={12}>
                       <Typography variant="subtitle1" sx={{ marginBottom: 1 }}>
                         Start Date
                       </Typography>
                       <TextField
                       variant="outlined"
                         type="date"
                         size="small"
                        className={classes.textField}
                         value={startDate}
                         onChange={(e) => setStartDate(e.target.value)}
                         InputLabelProps={{ shrink: true }}
                         
                       />
                     </Grid>
                     <Grid item lg={2} md={2} sm={6} xs={12}>
                       <Typography variant="subtitle1" sx={{ marginBottom: 1 }}>
                         End Date
                       </Typography>
                       <TextField
                         type="date"
                         size="small"
                        className={classes.textField}
                         value={endDate}
                         onChange={(e) => setEndDate(e.target.value)}
                         InputLabelProps={{ shrink: true }}
                  
                       />
                     </Grid>
                   </>
                 )} */}
               {/* </Grid> */}
             {/* </Box> */}
           </Card>
         </Grid>
       </Grid>
     </div>

  <div ref={componentRef} >
    <Card className={classes.card}>
      <Grid
        container

        spacing={5}
        sx={{ borderBottom: 2, padding: 2 }}
        className={classes.titleGrid}
      >
        <Grid item lg={4} md={4} sm={4} xs={4} pt={2} alignContent={"center"}>
          <Typography className={classes.cardTitle}>New Bills</Typography>
        </Grid>
        <Grid
          item
          lg={8}
          md={8}
          sm={8}
          xs={8}
          sx={{ display: "flex", justifyContent: "flex-end" }}
        >
          <Grid
            container
            spacing={1}
            justifyContent="flex-end"
            sx={{ display: "flex" }}
          >
            <Grid item sx={{ '@media print': {
                      display: 'none',
                    } }}>
              <TextField
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <CiSearch className={classes.searchWidgetIcon} />
                    </InputAdornment>
                  ),
                  classes: {
                    root: classes.formControlList,
                  },
                }}
                fullWidth
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Purchase Order Number .."
                sx={{ width: "100%" }}
                size="small"
              />
            </Grid>

            {/* {filteredCoursings.length > 0 && (
  <Grid item sx={{ '@media print': {
    display: 'none',
  } }}>
    <ReactToPrint
      trigger={() => (
        <Button
          variant="contained"
          startIcon={<LocalPrintshopSharpIcon />}
          className={classes.addButton}
        >
          Print
        </Button>
      )}
      content={() => componentRef.current}
    />
  </Grid>
)} */}

            <Grid item sx={{ '@media print': {
                      display: 'none',
                    } }}>
              <Button
                variant="contained"
                className={classes.addButton}
                onClick={handleAddProductClick}
              >
                Add Bill
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid>
        <TableContainer>
        <Table
  sx={{
    width: "100%",
    marginBottom: "1.5rem",
    verticalAlign: "top",
    "& > :not(caption) > * > *": {
      padding: "4px", // Ensure custom padding is applied
    },
  }}
>
            <TableHead className={classes.tableHeaderRow}>
              <TableRow>
                <TableCell className={classes.tablheader}>
                  <CustomCheckbox name="checkbox" />
                </TableCell>
                <TableCell className={classes.tablheader}>
                  <strong>#</strong>
                </TableCell>
                <TableCell className={classes.tablheader}>
                  <strong>Purchase Order Number</strong>
                </TableCell>
                <TableCell className={classes.tablheader}>
                  <strong>Status</strong>
                </TableCell>
                <TableCell className={classes.tablheader}>
                  <strong>Amount</strong>
                </TableCell>
                {/* <TableCell className={classes.tablheader}>
                  <strong>Paid Amt</strong>
                </TableCell>
                <TableCell className={classes.tablheader}>
                  <strong>Balance</strong>
                </TableCell> */}
                <TableCell className={classes.tablheader}>
                  <strong>Issue For</strong>
                </TableCell>
                <TableCell className={classes.tablheader}>
                  <strong>Issue From</strong>
                </TableCell>
               
                <TableCell
                  className={classes.tablheader}
                sx={{ textAlign: "right" ,'@media print': {
                      display: 'none',
                    } }}
                >
                  <strong>Actions</strong>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {isError || filteredCoursings.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={20} align="center">
                    {isError ? "Error fetching data" : "No data available"}
                  </TableCell>
                </TableRow>
              ) : (
                filteredCoursings
            // .filter((row: IQuoteWorkOrder) => Number(row.quoteWorkOrderCompanyId) === 1)
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row: IQuoteWorkOrder, index) => {
                    const statusLabel = getStatusLabel(
                      row.quoteWorkOrderStatus
                    );
                    const statusColor = getStatusColor(
                      row.quoteWorkOrderStatus
                    );

                    const invoice = invoiceList?.find((invoice) =>
                      String(invoice.id) === String(row.invoiceId)
                    );

                    const invoiceNo = invoice ? invoice.InvoiceNo : "N/A";
                    const invoiceAmt = invoice ? invoice.quoteWorkOrderSaleGrandTotal : 0;
                    const invoiceStatus = invoice ? invoice.quoteWorkOrderStatus : null;
                    const statusForLabel = invoiceStatus === null ? 0 : invoiceStatus; 
                    const invoiceStatusLabel = getStatusLabel(statusForLabel);
                    const invoiceStatusColor = getStatusColor(statusForLabel);
                   
                    const invoiceQuoteWorkOrderStatus = invoice ? invoice.quoteWorkOrderStatus : "N/A";
                    const amountPaid = invoice ? parseFloat(String(invoice.amount_paid) || "0") : 0;
                    const balance = invoice
                    ? Math.max(0, parseFloat(invoice.quoteWorkOrderSaleGrandTotal || "0") - amountPaid)
                    : parseFloat(row.quoteWorkOrderSaleGrandTotal || "0");
                      const formatAmount = (amount: any): string => {
  const parsed = parseFloat(amount);
  return !isNaN(parsed) ? parsed.toFixed(2) : "0.00";
};

                    return (
                      <TableRow key={row.id} className={classes.tableRowHover}>
                        <TableCell className={classes.tablCell}>
                          <CustomCheckbox name="checkbox" />
                        </TableCell>
                        <TableCell scope="row" className={classes.tablCell}>
                          {page * rowsPerPage + index + 1}
                        </TableCell>


                       <TableCell
  component="th"
  scope="row"
  className={classes.tablCell} style={{ whiteSpace: "nowrap"}}
>
{/* <span
    style={{ cursor: "pointer"}}
    onClick={() =>   navigate(`/work-order/history/${row.id}`)} // Navigate on click
  >
    {row.quoteWorkOrderNo}
  </span> */}

  <Link   to={`/work-order/history/${row.id}`} // Replace with the correct path to your desired page
    style={{ textDecoration: 'none', color: 'inherit',cursor: 'pointer', }} >
  
 <Box display="inline-flex" alignItems="center">
    {row.quoteWorkOrderNo}
         &nbsp;
     <LinkIcon fontSize="small" />
</Box>
          </Link> 

  {row.invoiceId && (
   
     <Link
      style={{
        backgroundColor: '#4caf50',
        color: '#fff',
        borderRadius: '12px',
        padding: '2px 8px',
        marginLeft: '8px',
        fontSize: '0.7rem',
        fontWeight: '500',
        cursor: 'pointer',
        whiteSpace: "nowrap", 
        textDecoration: 'none',
      }}
         to={`/invoice/history/${row.invoiceId}`}
    >
      <Box display="inline-flex" alignItems="center">
     {invoiceNo}
        &nbsp;
     <LinkIcon fontSize="small" />
</Box>
    </Link>
  )}
</TableCell>
<TableCell scope="row" className={classes.tablCell}>
                          <Button
                            className={classes.statusButtonList}
                            style={{
                              color: invoiceStatus != null ? invoiceStatusColor : statusColor,
                            
                              backgroundColor: invoiceStatus != null ?
                            
                              invoiceQuoteWorkOrderStatus === WorkOrderStatus.Paid
                              ? "#e1f8d5"
                              : invoiceQuoteWorkOrderStatus === WorkOrderStatus.Cancel
                              ? "#f8d7da"
                              : invoiceQuoteWorkOrderStatus === WorkOrderStatus.Pending
                              ? "lightyellow"
                              : invoiceQuoteWorkOrderStatus === WorkOrderStatus.Initiated
                              ? "#e2fafa"
                              : "#ffffff" // Fallback for other statuses
                              
                              : 
                              row.quoteWorkOrderStatus === WorkOrderStatus.Paid
                              ? "#e1f8d5"
                              : row.quoteWorkOrderStatus === WorkOrderStatus.Cancel
                              ? "#f8d7da"
                              : row.quoteWorkOrderStatus === WorkOrderStatus.Pending
                              ? "lightyellow"
                                : row.quoteWorkOrderStatus === WorkOrderStatus.Initiated
                              ? "#e2fafa"
                              : "#ffffff", // Fallback for other statuses
                              border: "solid 1px",
                              borderColor: invoiceStatus != null ? invoiceStatusColor : statusColor,
                              borderRadius: "8px",
                              
                            }}
                          >
                            {invoiceStatus != null? invoiceStatusLabel : statusLabel}
                      
                          </Button>
                        </TableCell>
                       
           <TableCell component="th" scope="row" className={classes.tablCell}>
  {"$"}
  {(Number(row.quoteWorkOrderSaleGrandTotal ?? 0)
  ).toFixed(2)}
</TableCell>


                                                {/* <TableCell component="th" scope="row" className={classes.tablCell}>
      {"$"}{invoice ? formatAmount(amountPaid) : "0.00"}
    </TableCell>
    <TableCell component="th" scope="row" className={classes.tablCell}>
      {"$"}{formatAmount(balance)}
    </TableCell>   */}
                        <TableCell scope="row" className={classes.tablCell}>
                          {row.company.companyName || null || ""}
                        </TableCell>
                        <TableCell scope="row" className={classes.tablCell}>
                          <Grid container >
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              {row.customer?.customerCompanyName || null || ""}
                            </Grid>
                           <Grid item lg={12} md={12} sm={12} xs={12}>


                            <Link to={`/customer-history/${row.quoteWorkOrderCustomerId}`} // Replace with the correct path to your desired page
                         style={{ textDecoration: 'none', display:'flex', color: 'inherit',cursor: 'pointer', }} >
                                
                            {`(${row.customer?.customerFirstName?.charAt(0).toUpperCase() + row.customer?.customerFirstName?.slice(1).toLowerCase() || ""} 
${row.customer?.customerLastName?.charAt(0).toUpperCase() + row.customer?.customerLastName?.slice(1).toLowerCase() || ""})`}
     &nbsp;
  <LinkIcon fontSize="small" />
      </Link>  
                            </Grid>
                          </Grid>
                        </TableCell>
                       
                        <TableCell scope="row" className={classes.tablCell}>
                          <Grid
                            container
                            spacing={1}
                            sx={{ display: "flex", justifyContent: "flex-end" }}
                          >
   <Grid item  sx={{ '@media print': {
                                                  display: 'none',
                                                } }}>
                                <Button
                                variant="contained"
                               className={classes.viewButtonList}
                                  onClick={() => handleOpenViewQuote(String(row.id))}
                               >
                               <DescriptionIcon 
                                className={classes.viewListIcon}
                                />
                                </Button>
                                </Grid>
{/* 
                            <Grid item sx={{ '@media print': {
                      display: 'none',
                    } }}>
                            <Link className={classes.viewButtonList}
                                                        to={`/work-order/history/${row.id}`} // Replace with the correct path to your desired page
                                                        style={{ textDecoration: 'none', color: 'inherit',cursor: 'pointer', }} // Optional: style to remove link styling
                                                      >
                                <VisibilitySharpIcon
                                  className={classes.viewListIcon}
                                />
                                </Link>
                            </Grid> */}
                            {/* <Grid item sx={{ '@media print': {
                      display: 'none',
                    } }}>
                              <Button
                                variant="contained"
                                className={classes.editButtonList}
                                onClick={() =>
                                  navigate(`/bill-history/${row.id}`)
                                }
                              >
                                <EditSharpIcon
                                  className={classes.editListIcon}
                                />
                              </Button>
                            </Grid> */}

                            {/* <Grid item>
                              <Button
                                variant="contained"
                                className={classes.deleteButtonList}
                                // onClick={() => handleOpenDeletePopup(row)}
                              >
                                <DeleteOutlineSharpIcon
                                  className={classes.deleteButtonList}
                                />
                              </Button>
                            </Grid> */}
                          </Grid>
                        </TableCell>
                      </TableRow>
                    );
                  })
              )}
            </TableBody>
          </Table>
          <Grid sx={{ '@media print': {
                      display: 'none',
                    } }}
            spacing={5}
            p={"18px"}
            py={4}
            justifyContent={"end"}
            container
            textAlign={"center"}
            alignContent={"center"}
            alignItems={"center"}
          >
            <Grid
              sx={{
                textAlign: "end",
                justifyContent: "flex-end",
                alignItems: "flex-end",
              }}
            >
              <Pagination
                count={filteredCoursings.length}
                page={page}
                rowsPerPage={rowsPerPage}
                onPageChange={handleChangePage}
              />
            </Grid>
          </Grid>
        </TableContainer>

        {coursingToDelete && (
          <DeletePopup
            open={openDeleteCategory}
            handleCloseDelete={handleCloseDeletePopup}
            onConfirm={async () => {
              await handleDelete(coursingToDelete.id.toString());
            }}
            title="Delete Quote"
            content={`Are you sure you want to delete "${coursingToDelete.quoteWorkOrderNo}"?`}
          />
        )}
      </Grid>
    </Card>
       </div>

     {openViewQuote && (
<Dialog open={openViewQuote} onClose={handleCloseViewQuote} maxWidth="md" fullWidth
  fullScreen={isMobile} 
>
<DialogTitle><Typography variant="h5" component="div">
Bill Details
</Typography></DialogTitle>
<DialogContent >
<ViewWorkOrder  quoteId={quoteId} type="view" /> 
</DialogContent>
<DialogActions>
 <Button onClick={handleCloseViewQuote}>Close</Button>
</DialogActions>
</Dialog>
)}

       </>
  );
};

export default Index;
